import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import ReactPlayer from 'react-player';
import { Helmet } from 'react-helmet';
import THEATER_DETAILS_QUERY from '../../../graphql/TheaterDetails';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import ProductionGrid from '../../../components/Production/ProductionGrid';
import { TheaterFeature } from '../../../components/Features/index';
import Authorization from '../../../components/Authorization/index';
import ContactTheaterForm from '../../Others/ContactTheaterForm';
import ToggleTheaterFavorite from '../../Others/ToggleTheaterFavorite';
import IsGuest from '../../../utils/IsGuest';
import { ADMIN_ROLE, THEATER_ADMIN_ROLE, FREE_PLAN } from '../../../constants';
import Carousel from '../../../components/Carousel';

const FEATURES_COLUMNS_NUMBER = 2;

class TheaterPage extends Component {
  renderFeatureColumn = (theater, column, sections) => {
    const auxFeatures = [];
    for (let i = 0; i < sections; i++) {
      if (theater.features.length > column + i * FEATURES_COLUMNS_NUMBER) {
        const feature = theater.features[column + i * FEATURES_COLUMNS_NUMBER];
        auxFeatures.push(feature);
      }
    }
    return (
      <div>
        {auxFeatures.map(feature => (
          <li key={feature.id}>
            <TheaterFeature feature={feature} />
          </li>
        ))}
      </div>
    );
  };

  renderFeatures = theater => {
    const featureQtty = theater.features.length;
    const sections =
      Math.floor(featureQtty / FEATURES_COLUMNS_NUMBER) +
      (featureQtty % FEATURES_COLUMNS_NUMBER === 0 ? 0 : 1);
    return (
      <div>
        {[0, 1].map(column => (
          <div key={column} className="col-md-6 col-sm-6 col-xs-12">
            <ul key={column} className="condition">
              {this.renderFeatureColumn(theater, column, sections)}
            </ul>
          </div>
        ))}
      </div>
    );
  };

  renderTheaterContent = (theater, isTheaterFree) => {
    let auxImages = [];
    if (isTheaterFree && theater.images[0]) auxImages.push(theater.images[0]);
    else auxImages = theater.images;
    return (
      <div className="properties-details-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="properties-details-section">
                <div className="clearfix m-b-lg m-l-sm">
                  <div className="pull-left">
                    <h3>
                      <img
                        width="30px"
                        alt="Theater Icon"
                        src="/img/theatre-masks.svg"
                      />
                      &nbsp;{theater.name}
                      {theater.facebook && (
                        <a
                          style={{ marginLeft: '20px' }}
                          href={theater.facebook}
                          target="_blank"
                        >
                          <i className="fa fa-facebook-square" />
                        </a>
                      )}
                    </h3>
                  </div>
                  {!IsGuest() && theater && theater.id && (
                    <div className="pull-right">
                      <div className="favorites__wrapper">
                        <ToggleTheaterFavorite
                          id={theater.id}
                          favorite={theater.favorite}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="pull-right col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div className="properties-detail-slider simple-slider mrg-btm-40 ">
                    <Carousel id="theaters" images={auxImages} />
                  </div>
                  <div className="col-md-12">
                    <div className="sidebar right">
                      <div className="thumbnail recent-properties-box">
                        <div className="caption detail">
                          <header className="clearfix">
                            <div className="pull-left">
                              <h1 className="title">Suscríbete</h1>
                            </div>
                          </header>
                          <h3 className="location">
                            <a href="">
                              ¿Quieres sacar más provecho de Escena Digital?
                            </a>
                          </h3>

                          <a href="/plans" target="_blank" className="book-btn">
                            <span className="book-btn-l">
                              <i className="fa fa-link" />
                            </span>
                            <span className="book-btn-r">Cambiar mi plan</span>
                            <div className="clear" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <ContactTheaterForm id={theater.id} />
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div className="properties-condition">
                    <div className="row">
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <ul className="condition">
                          <li>
                            <i className="fa fa-link" />
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={theater.website}
                            >
                              {theater.website}
                            </a>
                          </li>
                          <li>
                            <i className="fa fa-building-o" />
                            {`${theater.address}, ${theater.city}`}
                          </li>
                        </ul>
                      </div>
                      {!isTheaterFree && (
                        <div className="col-md-6 col-sm-6 col-xs-12">
                          <ul className="condition">
                            <li>
                              <i className="fa fa-user-o" />
                              {`${
                                theater.director
                                  ? theater.director
                                  : 'Sin director'
                              }`}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>

                  {!isTheaterFree && (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="properties-condition mrg-btm-40 ">
                          <h5 className="heading">Detalles técnicos</h5>
                          <Authorization
                            allowedPlans={[FREE_PLAN]}
                            denied={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}
                          >
                            <div className="alert alert-warning wow fadeInLeft delay-03s">
                              <strong>¡Bienvenido!</strong>
                              Para descargar los archivos, debes tener un plan
                              pagado.
                            </div>
                          </Authorization>
                          <div className="row">
                            {this.renderFeatures(theater)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {theater.biography && !isTheaterFree && (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="properties-condition mrg-btm-40 ">
                          <h5 className="heading">Biografía</h5>
                          <p>{theater.biography}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-md-6">
                      {theater.trailer && (
                        <div>
                          <h3>Trailer</h3>
                          <ReactPlayer
                            controls
                            url={theater.trailer}
                            width="100%"
                            height="100%"
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      {theater.video && (
                        <div>
                          <h3>Video</h3>
                          <ReactPlayer
                            controls
                            url={theater.video}
                            width="100%"
                            height="100%"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="clearfix" />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="main-title">
              <h2>Últimas producciones</h2>
              <div className="border">
                <div className="border-inner" />
              </div>
            </div>

            <Authorization
              deniedPlans={[FREE_PLAN]}
              allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}
            >
              <ProductionGrid productions={theater.productions || []} />
            </Authorization>
            <Authorization
              allowedPlans={[FREE_PLAN]}
              denied={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}
            >
              <div className="alert alert-warning wow fadeInLeft delay-03s">
                Existen {theater.productions.length} producciones asociadas a
                este teatro
              </div>
            </Authorization>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { theater, history, isTheaterFree } = this.props;

    if (theater && !theater.active) {
      history.push('/404');
    }

    return (
      <div>
        <Helmet>
          <title>
            {(theater && theater.name) || 'Teatro sin nombre'} - Escena
            Marketplace
          </title>
        </Helmet>
        <Banner />
        {theater !== undefined ? (
          this.renderTheaterContent(theater, isTheaterFree)
        ) : (
          <div />
        )}
        <Footer />
      </div>
    );
  }
}

const withDetails = graphql(THEATER_DETAILS_QUERY, {
  options: ({ match }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      slug: match.params.theaterSlug
    }
  }),
  props: ({ data }) => ({
    loading: data.loading,
    theater: data.theater,
    isTheaterFree: data.theater ? data.theater.plan === FREE_PLAN : false
  })
});

export default withDetails(TheaterPage);



// WEBPACK FOOTER //
// ./src/containers/General/TheaterPage/index.js